export default __webpack_public_path__ + "locales/pt-BR/Translations.json?hash=e6a011f7cd2ca2d2da4cbf830c310a42";